module.exports = __webpack_public_path__ + "static/media/ascendingIcon.e002a694.svg";